<template>
  <div id="app">
    <div class="content">
      <router-view v-slot="{ Component }">
        <keep-alive :exclude="['Play']">
          <component :is="Component"/>
        </keep-alive>
      </router-view>
    </div>
    <tab v-show="showTab"></tab>
  </div>
</template>

<script>
import Tab from '@/components/tab/tab'
import { onMounted, computed } from 'vue' // 引入 computed
import { useRoute } from 'vue-router'
import { useUserStore } from '@/store/user'
import { useWalletStore } from '@/store/walletStore'
import { useTimerStore } from '@/store/timerStore'
import { usePWA } from '@/assets/js/usePWA.js'

export default {
  name: 'App',
  components: {
    Tab
  },
  setup() {
    const userStore = useUserStore()
    const walletStore = useWalletStore()
    const timerStore = useTimerStore()
    const route = useRoute()

    usePWA()

    // 计算当前页面是否需要显示 Tab
    const showTab = computed(() => {
      return route.meta && route.meta.showTab
    })

    onMounted(() => {
      userStore.initUserSession()
      userStore.initClientIpInfo()
      walletStore.initProduct()
      timerStore.start()
    })

    return {
      showTab
    }
  }
}
</script>

<style lang="scss">
/* --- 全局变量 --- */
:root {
  --app-width: 100%;
  --tab-height: 50px;
}

/* --- PC端 触发条件：大于 800px --- */
@media screen and (min-width: 600px) {
  :root {
    --app-width: 480px; /* PC端锁定宽度 */
  }
}

/* --- 基础重置 --- */
body, html {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow: hidden; /* 禁止浏览器默认滚动 */
  background-color: #0f0524;
}
/* --- App 容器 (外壳) --- */
/* 它不负责滚动，只负责定位置和大小 */
#app {
  position: relative; /* 为 Tab 的 absolute 提供定位基准 */
  width: 100%;
  max-width: var(--app-width); /* 响应式宽度 */
  height: 100%; /* 占满屏幕高度 */
  margin: 0 auto; /* PC居中 */
  background-color: #0f0524;
  overflow: hidden; /* 裁剪超出部分 */
  display: flex;
  flex-direction: column;
  transform: translate(0, 0);
  overflow: hidden;
}

/* --- 内容区域 --- */
.content {
  flex: 1;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch; /* 顺滑滚动 */
  overflow-x: hidden;

    /* 注意：既然开启了滚动，Home.vue 里的 min-height: 100vh 就能起作用了 */
  padding-bottom: env(safe-area-inset-bottom); /* 只需要处理安全区，Tab 的占位交给布局 */
}

@media screen and (min-width: 800px) {
  body {
    background-color: #1e1e1e;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  #app {
    height: 100vh;
    box-shadow: 0 0 30px rgba(0, 0, 0, 0.5);
  }
}
</style>
